import styled from 'styled-components';
import { colors } from "../../utils/colors";

export const SuccessfulDiv = styled.div`
    width: 90%;
    max-width: 500px;
    margin: 0 auto;
    text-align: center;
    background-color: ${colors.BLUE};
    padding: 40px 30px;
    border-radius: 10px;
    -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    -moz-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);

    @media (max-width: 500px) {
        background-color: transparent;
        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        box-shadow: none;
        padding: 40px 10px;
    }
`;

export const SuccessfulP = styled.p`
    color: ${colors.WHITE};
    margin-bottom: 30px;
`;
